import { Injectable, OnDestroy } from "@angular/core";
import { BehaviorSubject, Subject } from "rxjs";

@Injectable({ providedIn: "root" })
export class ProcessInterfacesFilterService implements OnDestroy {
	private destroy$ = new Subject<boolean>();
	searchTerm$: BehaviorSubject<string> = new BehaviorSubject<string>("");
	filterType$: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);
	isFilterToolbarVisible$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

	setSearchTerm(searchTerm: string): void {
		this.searchTerm$.next(searchTerm);
	}

	setFilterType(filterType: string): void {
		this.filterType$.next(filterType);
	}

	setFilterToolbarVisible(isVisible: boolean): void {
		this.isFilterToolbarVisible$.next(isVisible);
	}

	ngOnDestroy(): void {
		this.destroy$.next(true);
		this.destroy$.complete();
	}
}
